import { render, staticRenderFns } from "./CommitteeMembers.vue?vue&type=template&id=61d4df29&scoped=true"
import script from "./CommitteeMembers.vue?vue&type=script&lang=js"
export * from "./CommitteeMembers.vue?vue&type=script&lang=js"
import style0 from "./CommitteeMembers.vue?vue&type=style&index=0&id=61d4df29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d4df29",
  null
  
)

export default component.exports